import pluginCenter from "../../api/pluginCenter";

const state = {
    //  打卡列表
    knowledgeListLoading: false,
    knowledgeList: {},
    knowledgeListFilter: {},
    ClockDetailsModalVisible: false,
    //   试卷
    testPaperListLoading: false,
    testPaperList: {},
    testPaperListFilter: {},
    testPaperMapList: {},
    addTestPaperModalVisible: false,
    //   试题
    testQuestionListLoading: false,
    canAddTestQuestionListLoading: false,
    testQuestionList: {},
    canAddTestQuestionList: {},
    testQuestionListFilter: {},
    canAddTestQuestionListFilter: {},
    addQuestionModalVisible: false,
    activeTab: "0",
};

const getters = {};
const mutations = {
    setData(state, {key, value}) {
        state[key] = value;
    },
    clearFilter(state) {
        state.knowledgeListFilter = {};
        state.testPaperListFilter = {};
    },
};
const actions = {
    // eslint-disable-next-line no-empty-pattern
    async getKnowledgeList({commit}, payload) {
        commit("setData", {key: "knowledgeListLoading", value: true});
        try {
            var params = {};
            // 为了处理 过滤参数和分页器参数
            if (
                state.knowledgeListFilter.dateRange &&
                state.knowledgeListFilter.dateRange.length === 2
            ) {
                params = {
                    size: state.knowledgeList.size,
                    ...state.knowledgeListFilter,
                    ...payload,
                    startTime: state.knowledgeListFilter.dateRange
                        ? state.knowledgeListFilter.dateRange[0]
                        : null,
                    endTime: state.knowledgeListFilter.dateRange
                        ? state.knowledgeListFilter.dateRange[1]
                        : null,
                };
            } else {
                params = {
                    size: state.knowledgeList.size,
                    ...state.knowledgeListFilter,
                    ...payload,
                };
            }
            const res = await pluginCenter.getKnowledgeList.getList(params);
            commit("setData", {key: "knowledgeList", value: res.data});
        } finally {
            commit("setData", {key: "knowledgeListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async saveKnowledge({}, payload) {
        await pluginCenter.saveKnowledge(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteKnowledge({}, payload) {
        await pluginCenter.deleteKnowledge(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getTestPaperList({commit}, payload) {
        commit("setData", {key: "testPaperListLoading", value: true});
        try {
            var params = {};
            // 为了处理 过滤参数和分页器参数
            if (
                state.testPaperListFilter.dateRange &&
                state.testPaperListFilter.dateRange.length === 2
            ) {
                params = {
                    size: state.testPaperList.size,
                    ...state.testPaperListFilter,
                    ...payload,
                    startTime: state.testPaperListFilter.dateRange
                        ? state.testPaperListFilter.dateRange[0]
                        : null,
                    endTime: state.testPaperListFilter.dateRange
                        ? state.testPaperListFilter.dateRange[1]
                        : null,
                };
            } else {
                params = {
                    size: state.testPaperList.size,
                    page: state.testPaperList.page,
                    ...state.testPaperListFilter,
                    ...payload,
                };
            }
            const res = await pluginCenter.getTestPaperList.getList(params);
            commit("setData", {key: "testPaperList", value: res.data});
            return res;
        } finally {
            commit("setData", {key: "testPaperListLoading", value: false});
        }
    },
    async getTestPaperMapList({commit}, payload) {
        const res = await pluginCenter.getTestPaperList.getList(payload);
        commit("setData", {key: "testPaperMapList", value: res.data});
        return res;
    },

    // eslint-disable-next-line no-empty-pattern
    async getTestQuestionList({commit}, payload) {
        commit("setData", {key: "testQuestionListLoading", value: true});
        try {
            var params = {
                size: state.testQuestionList.size,
                page: state.testQuestionList.page,
                ...state.testQuestionListFilter,
                ...payload,
            };
            const res = await pluginCenter.getTestQuestionList.getList(params);
            commit("setData", {key: "testQuestionList", value: res.data});
            return res;
        } finally {
            commit("setData", {key: "testQuestionListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async getCanAddTestQuestionList({commit}, payload) {
        commit("setData", {key: "canAddTestQuestionListLoading", value: true});
        try {
            var params = {
                size: state.canAddTestQuestionList.size,
                page: state.canAddTestQuestionList.page,
                ...state.canAddTestQuestionListFilter,
                ...payload,
            };
            const res = await pluginCenter.getCanAddTestQuestionList.getList(params);
            commit("setData", {key: "canAddTestQuestionList", value: res.data});
            return res;
        } finally {
            commit("setData", {key: "canAddTestQuestionListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async moveTestQuestion({}, payload) {
        var params = {
            ...state.testQuestionListFilter,
            ...payload,
        };
        await pluginCenter.moveTestQuestion(params);
    },
    // eslint-disable-next-line no-empty-pattern
    async importTestPaper({}, payload) {
        await pluginCenter.importTestPaper(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteTestPaper({}, payload) {
        await pluginCenter.deleteTestPaper(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deployTestPaper({}, payload) {
        return await pluginCenter.deployTestPaper(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteTestPaperQuestion({}, payload) {
        return await pluginCenter.deleteTestPaperQuestion(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async saveTestQuestion({}, payload) {
        return await pluginCenter.saveTestQuestion(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async saveTestPaperQuestion({}, payload) {
        return await pluginCenter.saveTestPaperQuestion(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async saveTestPaper({}, payload) {
        return await pluginCenter.saveTestPaper(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async createTestPaper({}, payload) {
        return await pluginCenter.createTestPaper(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getTestPaperTestReport({}, payload) {
        return await pluginCenter.getTestPaperTestReport(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getUserTestReport({}, payload) {
        return await pluginCenter.getUserTestReport(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async generateQRCode({}, payload) {
        return await pluginCenter.generateQRCode(payload);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
